import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import {
  QueryStandardSuccessResponse,
  MutationAdminChangePasswordRequestBody,
  APIStandardError,
} from "../../../types";
import { CHANGE_PASSWORD } from "../../../api/queryKeys";

const changePassword = (data: MutationAdminChangePasswordRequestBody) =>
  api.post(CHANGE_PASSWORD, data).then((res) => res.data);

export default function useChangePassword({
  onSuccessHandler,
}: {
  onSuccessHandler?: () => void;
}) {
  return useMutation<
    QueryStandardSuccessResponse,
    AxiosError,
    MutationAdminChangePasswordRequestBody
  >(changePassword, {
    onSuccess: (data) => {
      toast.success("Password changed successfully");

      if (onSuccessHandler) {
        onSuccessHandler();
      }
    },
    onError: (error) => {
      const errorData = error.response?.data as APIStandardError;
      if (errorData.new_password?.length) {
        toast.error(errorData.new_password[0]);
        return;
      }
      if (errorData.old_password?.length) {
        toast.error(errorData.old_password[0]);
        return;
      }
      toast.error("Error changing password");
    },
  });
}
